import React from 'react';

import { Carousel } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import { convertStyleData, transformPx2Rem } from '@utils/tools';
import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';

import CustomComponent from '../CustomComponent';

import './SlidingPanelCustomComponent.less';

export default class SlidingPanelCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    let compindex = props.index;
    let pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    const compData = this.props.data;
    clearInterval(compData.slideInterval);
    pageInstance.setData({
      ['eles[' + compindex + '].customFeature.slideIndex']: 0
    });
    if (compData.customFeature.autoplay && compData.customFeature.interval){
      this.slideSwiper({
        pageInstance: pageInstance,
        compindex: compindex
      })
    }
    if (compData.customFeature.vesselMode === 2) { // 滑动面板
      let customFeature = compData.customFeature;
      let activeIndex = 0;
      let scaleDegree = 1;
      customFeature.proportion > 1 && (scaleDegree = Math.round(100 / customFeature.proportion) / 100);
      pageInstance.setData({
        ['eles[' + compindex + '].activeIndex']: activeIndex,
        ['eles[' + compindex + '].scaleDegree']: scaleDegree,
        ['eles[' + compindex + '].reference']: customFeature.reference || 0.618
      });
      this.slidePanelSetBoundingClientRectInfo(pageInstance, compindex);
    }
  }

  slideSwiper = (options) => {
    let compData = options.pageInstance.data.eles[options.compindex];
    options.pageInstance.data.eles[options.compindex].slideInterval = setInterval(() =>{
      let index = compData.customFeature.slideIndex;
      let direction = '_interval'
      if (index >= compData.content.length ){
        index = 0;
      }else {
        index += 1;
      }
      this.slideAnimation({
        compindex: options.compindex,
        num: index,
        pageInstance: options.pageInstance,
        direction: direction
      })
    }, compData.customFeature.interval*1000)
  }

  // 滑动面板设置节点信息
  slidePanelSetBoundingClientRectInfo = (pageIns, compindex = -1, n) => {
    if (compindex === -1) {
      return;
    }
    let that = this,
      pageInstance = pageIns || app.getAppCurrentPage(),
      newData = {},
      containerSelector = '#sliding-panel-' + compindex,
      selector = containerSelector + ' .sildeItem';
    app.getBoundingClientRect(containerSelector, function (areaRect) {
      if (!areaRect.length) {
        if (isNaN(n)) {
          n = 0;
        }
        if (n < 10) {
          setTimeout(function () {
            that.slidePanelSetBoundingClientRectInfo(pageInstance, compindex, ++n);
          }, 300);
        }
        return;
      }
      let containerOffsetWidth = areaRect.shift().width;
      newData['eles[' + compindex + '].containerOffsetWidth'] = containerOffsetWidth;
      app.getBoundingClientRect(selector, function (itemRects) {
        let offsetArr = [],
          itemWidth = itemRects.length && itemRects[0].width || 0;
        if ((containerOffsetWidth == 0 || itemWidth == 0) && (isNaN(n) || n < 10)) {
          if (isNaN(n)) {
            n = 0;
          }
          setTimeout(function () {
            that.slidePanelSetBoundingClientRectInfo(pageInstance, compindex, ++n);
          }, 300);
          return;
        }
        offsetArr = itemRects.map((v, k) => itemWidth * (k + 1));
        newData['eles[' + compindex + '].offsetLeftArr'] = offsetArr;
        pageInstance.setData(newData);
      });
    });
  }

  // TODO： 应该没用
  slidePanelStart = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = e.currentTarget.dataset.compindex;
    let startX = e.changedTouches[0].clientX;
    clearInterval(pageInstance.data.eles[compindex].slideInterval);
    let data = {};
    data['eles[' + compindex + '].startX'] = startX;
    pageInstance.setData(data);
  }

  // TODO： 应该没用
  slidePanelEnd = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = e.currentTarget.dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let endX = e.changedTouches[0].clientX;
    let startX = compData.startX;
    let index = compData.customFeature.slideIndex;
    let direction
    if (Math.abs(startX - endX) > 50) {
      startX - endX > 0 ? index++ : index--;
      if (compData.customFeature.autoplay) {
        compData.slideInterval = setInterval(() => {
          let index = compData.customFeature.slideIndex;
          if (index >= compData.content.length ) {
            index = 0;
          } else {
            index += 1;
          }
          let direction = '_interval'
          this.slideAnimation({
            compindex: compindex,
            num: index,
            pageInstance: pageInstance,
            direction: direction
          })
        }, compData.customFeature.interval * 1000)
      } else {
        clearInterval(compData.slideInterval);
      }
      if (index >= compData.content.length || index < 0) {
        return;
      }
      this.slideAnimation({ compindex: compindex, num: index, pageInstance: pageInstance, direction: direction})
    }
  }

  slideAnimation = (params) => {
    // let animation = wx.createAnimation({
    //   duration: (params.num == 0 && params.direction) ? 0 : 500
    //   // duration: 500
    // });
    let length = (-750 * params.num) + 'rpx';
    let data = {};
    // animation.left(length).step();
    // data['eles[' + params.compindex + '].animations'] = animation.export();
    data['eles[' + params.compindex + '].customFeature.slideIndex'] = params.num
    params.pageInstance.setData(data);
  }

  slidePanelScrollEvent = (event, clear) => {
    let that = this;
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let activeIndex = JSON.parse(dataset.activeIndex);
    let offsetLeftArr = JSON.parse(dataset.offsetLeftArr);
    let containerOffsetWidth = JSON.parse(dataset.containerOffsetWidth);
    let { scrollLeft, scrollWidth } = event.detail;
    let compData = pageInstance.data.eles[compindex];
    let reference = +compData.reference;
    let timeoutId = null;
    let newData = {};
    let targetIndex = 0;
    let i = activeIndex;
    let l = offsetLeftArr.length;
    let flagOffset = containerOffsetWidth * reference + scrollLeft;

    if (scrollLeft < 20) {
      targetIndex = 0;
    } else if (scrollWidth - scrollLeft - containerOffsetWidth < 20) {
      targetIndex = l - 1;
    } else {
      if (flagOffset < offsetLeftArr[i]) {
        if (flagOffset < offsetLeftArr[i - 1]) {
          targetIndex = i - 1;
        }else {
          targetIndex = i;
        }
      } else {
        targetIndex = i + 1;
      }
    }

    if (activeIndex != targetIndex) {
      newData['eles[' + compindex + '].activeIndex'] = targetIndex;
    }

    if (!clear) {
      compData.timeoutId && clearTimeout(compData.timeoutId);
      timeoutId = setTimeout(function () {
        that.slidePanelScrollEvent(event, true);
      }, 140);
    }
    newData['eles[' + compindex + '].timeoutId'] = timeoutId;
    pageInstance.setData(newData);
  }

  render() {
    /**
     * 传入数据
     */ 
    const data = this.props.data;                // 组件数据
    const detailData = this.props.detailData;    // 详情页数据
    const dynamicData = this.props.dynamicData;  // 动态数据
    /**
     * 组件配置对象
     */  
    const customFeature = data.customFeature;
    /**
     * 样式数据处理
     */
    const styleObj = convertStyleData(data.style);
    const vesselMode2StyleObj = {
      ...styleObj,
      height: 'auto',
      width: 'auto',
      marginRight: transformPx2Rem(data.style['margin-left'], 320)
    }
    const secStyleObj = {
      marginLeft: data.customFeature.style['margin-left'],
      marginRight: data.customFeature.style['margin-right'],
      ...convertStyleData({
        'font-size': customFeature.secFontSize,
        'font-weight': customFeature.secFontWeight || 'normal',
        'font-style': customFeature.secFontStyle || 'normal',
        'text-decoration': customFeature.secTextDecoration || 'none',
        'color': customFeature.secColor,
        'text-align': customFeature.secTextAlign
      })
    };
    const mainStyleObj = {
      ...convertStyleData(customFeature.style),
      marginTop: transformPx2Rem(customFeature.style['margin-bt']),
      marginBottem: transformPx2Rem(customFeature.style['margin-bt']),
    };
    /**
     * 组件内容处理
     */   
    let content = data.content || [];
    /**
     * 返回组件
     */ 
    return (
      <div className={`custom-component sliding-panel vessel-mode-${customFeature.vesselMode || 1}`}>
        {/* 单面横滑 */}
        {customFeature.vesselMode === 1 &&
        <div className={`slide mode-${customFeature.mode} dots-${customFeature.navigateMode}`} style={styleObj}>
          <Carousel
            autoplay={customFeature.autoplay}
            autoplayInterval={customFeature.interval*1000}
            infinite
            dots={customFeature.mode !== -1}
            dotStyle={{background: customFeature.navigateDefaultColor}}
            dotActiveStyle={{background: customFeature.navigateActiveColor}}
          >
          {content.map((data, index) => 
            <div className="panel" key={index} style={{height:styleObj.height}}>
              {data.content.map((componentData, componentIndex) => 
                <CustomComponent key={componentIndex} index={componentIndex} data={componentData} detailData={detailData} dynamicData={dynamicData}/>
              )}
            </div>
          )}
          </Carousel>
        </div>
        }
        {/* 多面横滑 */}
        {
          customFeature.vesselMode === 2 && (
            <ScrollView
              scroll-x={true}
              className="slide-panel silde-panel-mode2"
              id={`sliding-panel-${this.props.index}`}
              style={vesselMode2StyleObj}
              bindscroll={this.slidePanelScrollEvent}
              data-compindex={this.props.index}
              data-offset-left-arr={JSON.stringify(data.offsetLeftArr || [])}
              data-active-index={JSON.stringify(data.activeIndex || 0)}
              data-container-offset-width={JSON.stringify(data.containerOffsetWidth)}>
              {
                data.content.map((item, contentIndex) => (
                  <div className="sildeItem" key={contentIndex}
                    style={{
                      transform: `scale(${contentIndex == data.activeIndex ? 1 : data.scaleDegree})`
                    }}
                    data-compindex={this.props.index}>
                    {
                      !!data.customFeature.isShowTitle &&
                      <div className="sildeItem-title"
                      style={secStyleObj}>{item.title || item.name}</div>
                    }
                    <div className="sildeItem-main" style={mainStyleObj}>
                      {
                        item.content.map((componentData, componentIndex) => 
                          <CustomComponent key={componentIndex} index={componentIndex} data={componentData} detailData={detailData} dynamicData={dynamicData}/>
                        )
                      }
                    </div>
                    {
                      !!data.customFeature.isShowNum && (
                      <div className="sildeItem-pagination">{(contentIndex + 1)+'/'+data.content.length}</div>
                      )
                    }
                  </div>
                ))
              }
            </ScrollView>
          )
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/sliding-panel-custom-component/SlidingPanelCustomComponent.jsx